"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var SharedWidgets_1 = require("../../SharedWidgets");
var dataUri = function (svg) { return "data:image/svg+xml," + encodeURIComponent(svg); };
var SplitButtonDropdownSvg = function (fillColor) { return "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"6\" height=\"4\">\n  <path fill=\"" + fillColor + "\" d=\"M5.8 0H.23c-.2 0-.3.2-.2.3l2.78 3.62c.1.1.2.1.3 0L5.88.3C6.05.1 6 0 5.8 0z\"/>\n</svg>"; };
var ButtonStyleName = TypeStyle.style({
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    marginRight: "0 !important",
    position: 'relative',
    $nest: {
        '&::after': {
            background: 'white',
            bottom: -1,
            content: "\"\"",
            position: 'absolute',
            right: -1,
            top: -1,
            width: 1,
        }
    }
});
var MenuButtonStyleName = TypeStyle.style({
    alignItems: 'center',
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    display: 'inline-flex',
    justifyContent: 'center',
    marginLeft: "0 !important",
    minWidth: "24px !important",
    padding: "0 5px !important",
    $nest: {
        '&::after': {
            width: 6,
        },
        '&:empty::after': {
            content: "url(" + dataUri(SplitButtonDropdownSvg('#fff')) + ")",
            height: 18,
        },
        '&&&[aria-expanded="true"]': {
            backgroundColor: '#BEDBF4', borderColor: '#BEDBF4', color: '#1A699E',
            $nest: {
                '&:empty::after': {
                    content: "url(" + dataUri(SplitButtonDropdownSvg('#1A699E')) + ")",
                }
            }
        }
    }
});
exports.SplitButtonWidget = function (props) {
    if (!(props.menuButton.props['aria-label'] || props.menuButton.props['aria-labelledby'])) {
        throw new Error('aria-label or aria-labelledby must be set on `menuButton` props.');
    }
    return React.createElement("div", { style: { display: 'inline-flex', whiteSpace: 'nowrap' } },
        React.cloneElement(props.button, {
            buttonType: SharedWidgets_1.ButtonType.Primary,
            className: TypeStyle.classes(props.button.props.className, ButtonStyleName),
            density: props.button.props.density || 'medium',
        }),
        React.cloneElement(props.menuButton, tslib_1.__assign({}, { kind: 'primary' }, { className: TypeStyle.classes(props.menuButton.props.className, MenuButtonStyleName), density: 'high' })));
};
//# sourceMappingURL=SplitButtonWidget.js.map